import { differenceInDays, format, fromUnixTime } from "date-fns"

export const formatLockEnds = (lockEnds: number) => {
  return format(fromUnixTime(lockEnds), "LLL do, yyyy")
}

export const formatDaysTilLockEnds = (lockEnds: number, when = new Date()) => {
  const days = differenceInDays(fromUnixTime(lockEnds), when)

  if (days > 0) {
    return `~${days} days`
  } else {
    return "-"
  }
}

export const formatEpochDate = (epochDate: Date) => format(epochDate, "MMM do, yyyy")
